import React, { useEffect, useState } from 'react';
import { Globe, ExternalLink, RefreshCw, Copy } from 'lucide-react';
import http from '../api/http';
import BlueHeader from '../components/BlueHeader';
import { PORTAIL_URL } from '../config/api';

const PortailRecrutement = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const res = await http.get('/api/public/recrutement/stats');
      setStats(res.data);
    } catch (e) {
      console.error(e);
      setStats(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const copyUrl = async () => {
    try {
      await navigator.clipboard.writeText(PORTAIL_URL);
      alert('URL copiée');
    } catch (e) {
      prompt('Copiez l\'URL du portail :', PORTAIL_URL);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <BlueHeader
        title="Portail de recrutement"
        subtitle="Espace public candidats"
        icon={Globe}
        actions={[
          { label: 'Actualiser', icon: RefreshCw, onClick: fetchStats, primary: false },
          {
            label: 'Ouvrir le portail',
            icon: ExternalLink,
            onClick: () => window.open(PORTAIL_URL, '_blank'),
            primary: true,
          },
        ]}
      />

      <div className="px-6 py-8 space-y-6">
        <div className="bg-white rounded-xl shadow-sm p-6">
          <h2 className="text-lg font-semibold text-blue-900 mb-2">URL publique</h2>
          <p className="text-sm text-gray-600 mb-4">
            Les candidats consultent les offres publiées et postulent sans compte administrateur.
            Seules les offres au statut <strong>Publiée</strong> sont visibles.
          </p>
          <div className="flex flex-wrap gap-2 items-center">
            <code className="rounded-lg bg-slate-100 px-3 py-2 text-sm text-slate-800">{PORTAIL_URL}</code>
            <button type="button" onClick={copyUrl} className="inline-flex items-center gap-1 px-3 py-2 bg-gray-200 rounded-md text-sm">
              <Copy className="h-4 w-4" /> Copier
            </button>
            <a
              href={PORTAIL_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1 px-3 py-2 bg-blue-600 text-white rounded-md text-sm"
            >
              <ExternalLink className="h-4 w-4" /> Ouvrir
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { label: 'Offres actives', value: stats?.offres_actives },
            { label: 'Candidatures reçues', value: stats?.candidatures },
            { label: 'Filiales avec offres', value: stats?.filiales_actives },
          ].map((card) => (
            <div key={card.label} className="bg-white rounded-xl shadow-sm p-5">
              <div className="text-xs uppercase tracking-wide text-gray-500">{card.label}</div>
              <div className="mt-2 text-3xl font-bold text-blue-900">
                {loading ? '…' : (card.value ?? 0)}
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white rounded-xl shadow-sm p-6 text-sm text-gray-600 space-y-2">
          <h3 className="font-semibold text-gray-900">Mode d&apos;emploi</h3>
          <ol className="list-decimal pl-5 space-y-1">
            <li>Créer une offre dans le menu <strong>Offres</strong>.</li>
            <li>Passer le statut à <strong>Publiée</strong> (icône globe ou formulaire).</li>
            <li>Partager l&apos;URL du portail aux candidats.</li>
            <li>Traiter les candidatures dans le menu <strong>Candidatures</strong>.</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default PortailRecrutement;
